import { render } from "./PageAcompanhamento.vue?vue&type=template&id=840c6ab0&scoped=true"
import script from "./PageAcompanhamento.vue?vue&type=script&lang=js"
export * from "./PageAcompanhamento.vue?vue&type=script&lang=js"

import "./PageAcompanhamento.vue?vue&type=style&index=0&id=840c6ab0&scoped=true&lang=css"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-840c6ab0"]])

export default __exports__